import { Add } from "@mui/icons-material";
import { FormGroup, Stack } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { GeneralButton } from "../../../../../common/ui/GeneralButton";
import { ScheduleTimePeriod } from "../../../../../types/actionModule/schedulingStrategy/schedulingStrategyType";
import { useTranslation } from "react-i18next";

export interface ScheduleTimeDefinitionEditorProps {
    timeModel: ScheduleTimePeriod[];
    onUpdateTimeModel: (value: ScheduleTimePeriod[]) => void;
}

export function ScheduleTimeDefinitionEditor(props: ScheduleTimeDefinitionEditorProps) {
    const { t } = useTranslation();
    const onAddNewTimeRange = () => {
        props.onUpdateTimeModel([
            ...props.timeModel,
            {
                startTime: null,
                endTime: null
            }
        ])
    }

    return <FormGroup sx={{ flexDirection: "column", gap: 1 }}>
        {
            props.timeModel.map((m) =>
                <Stack direction="row" sx={{ gap: 2 }}>
                    <DatePicker
                        value={m.startTime ? dayjs(m.startTime) : null}
                        onChange={(e) => {
                            props.onUpdateTimeModel(
                                props.timeModel.map(tm => tm === m ? {
                                    ...m,
                                    startTime: e?.toDate() ?? null
                                } : tm)
                            );
                        }}
                        sx={{ minWidth: 100, flex: 1 }}
                        label="Start" />
                    <DatePicker
                        value={m.endTime ? dayjs(m.endTime) : null}
                        onChange={(e) => {
                            props.onUpdateTimeModel(
                                props.timeModel.map(tm => tm === m ? {
                                    ...m,
                                    endTime: e?.toDate() ?? null
                                } : tm)
                            );
                        }}
                        sx={{ minWidth: 100, flex: 1 }}
                        label="Ende" />
                </Stack>
            )
        }
        <GeneralButton appVariant="icon" onClick={onAddNewTimeRange}>
            <Add /> {t("actionModules.schedulingStrategy.scheduleDefinition.time.add")}
        </GeneralButton>
    </FormGroup >
}